import { cn } from "@/lib/utils";
import ReactMarkdown, { Components } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

type MarkdownProps = {
  children: string | undefined;
  placeholder?: boolean;
  allowRawHtml?: boolean;
  className?: string;
  components?: Components;
};

export const Markdown: React.FC<MarkdownProps> = ({
  children,
  allowRawHtml = false,
  className,
  components,
}) => {
  return (
    <div className={cn("markdown", className)}>
      <ReactMarkdown
        rehypePlugins={allowRawHtml ? [rehypeRaw] : []}
        remarkPlugins={[remarkGfm]}
        components={components}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};
